/* eslint-disable multiline-ternary */
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { AnimateSharedLayout, motion } from 'framer-motion'
import {
  animationAppTransitions,
  animationAppVariants
} from '../component/Helpers/pageAnimation'
import { useGlobalState } from '../providers/GlobalState'
import { CataractType } from '../types/graphql'
import SimulationsButton from '../component/SimulationsButton'
import SimulationCarousel from '../component/SimulationCarousel'
import CataractTypeEdit from '../component/CataractTypeEdit'
import { useEditMode } from '../providers/EditMode'

interface ParamTypes {
  slug: string
}

const Catarata: React.FC = () => {
  const [activeType, setActiveType] = useState<
    CataractType | null | undefined
  >()
  const [url, setUrl] = useState<string>('thumb')
  const { editMode } = useEditMode()
  const [options, setOptions] = useState<
    { name: string; url: string | undefined; active?: boolean }[]
  >([])
  const { slug } = useParams<ParamTypes>()
  const { cataractTypes } = useGlobalState()

  const handleChange = (url: string) => {
    setUrl(url)
  }

  useEffect(() => {
    if (cataractTypes) {
      setActiveType(cataractTypes.find(x => x?.slug === slug))
    }
  }, [cataractTypes, slug])

  useEffect(() => {
    if (activeType) {
      setOptions([
        {
          name: 'Informativo',
          url: 'thumb',
          active: true
        },
        {
          name: 'Simulação',
          url: 'simulations',
          active: !!activeType.simulations.length
        },
        {
          name: '3D',
          url: 'iframe',
          active: !!activeType.iframe
        }
      ])
    }
  }, [activeType])

  const Content = (type: string) => {
    if (activeType) {
      switch (type) {
        case 'iframe':
          return (
            <div
              style={{
                position: 'relative',
                overflow: 'hidden',
                width: '100%',
                paddingTop:
                  '56.25%' /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */
              }}
            >
              <iframe
                src={activeType.iframe || ''}
                title={activeType.name}
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  bottom: 0,
                  right: 0,
                  width: '100%',
                  height: '100%'
                }}
              />
            </div>
          )
        case 'simulations':
          return <SimulationCarousel simulations={activeType.simulations} />
        default:
          return (
            <img
              src={activeType.thumb}
              alt={activeType.name}
              style={{ width: '100%', maxWidth: '1721px', margin: 'auto' }}
            />
          )
      }
    }
  }

  const Page = () => {
    return (
      <motion.div
        initial="initial"
        animate="in"
        exit="out"
        variants={animationAppVariants}
        transition={animationAppTransitions}
        style={{
          position: 'relative',
          background: 'linear-gradient(180deg, #666666 0%, #666666 143.29%)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          margin: 'auto'
        }}
      >
        {Content(url)}
      </motion.div>
    )
  }

  return (
    <AnimateSharedLayout>
      <Page />
      {editMode && <CataractTypeEdit />}
      {activeType && options[0] && (
        <SimulationsButton
          handleScenarioChange={handleChange}
          options={options}
          activeUrl={url}
        />
      )}
    </AnimateSharedLayout>
  )
}

export default Catarata
